
/**
 * CETEP FARMA
 * Límite de compra para medicamentos con receta.
 *
 * Regla: máximo 6 unidades por producto.
 * Se consideran todas sus variantes y líneas del carrito.
 */

(() => {
  const MAX_QUANTITY = 6;
  const productCache = new Map();

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('No se pudo consultar el carrito');
    }

    return response.json();
  }

  async function getProduct(handle) {
    if (!handle) {
      throw new Error('Producto sin handle');
    }

    if (!productCache.has(handle)) {
      const request = fetch(
        `/products/${encodeURIComponent(handle)}.js`,
        { credentials: 'same-origin' }
      ).then(response => {
        if (!response.ok) {
          throw new Error('No se pudo consultar el producto');
        }
        return response.json();
      });

      productCache.set(handle, request);
    }

    try {
      return await productCache.get(handle);
    } catch (error) {
      productCache.delete(handle);
      throw error;
    }
  }

  function hasReceta(product) {
    const tags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',');

    return tags.some(
      tag => String(tag).trim().toLowerCase() === 'receta'
    );
  }

  function countProduct(cart, productId) {
    return cart.items
      .filter(item => String(item.product_id) === String(productId))
      .reduce((total, item) => total + item.quantity, 0);
  }

  async function validateAdd({
    productId,
    handle,
    quantity
  }) {
    const amount = Number(quantity);

    if (!Number.isInteger(amount) || amount < 1) {
      return { allowed: false, message: 'Cantidad inválida.' };
    }

    const product = await getProduct(handle);

    if (!hasReceta(product)) {
      return { allowed: true };
    }

    const cart = await getCart();
    const current = countProduct(cart, productId || product.id);

    if (current + amount > MAX_QUANTITY) {
      return {
        allowed: false,
        message: `Solo puedes comprar un Máximo ${MAX_QUANTITY} unidades por producto con Receta Médica`
      };
    }

    return { allowed: true };
  }

  async function validateChange({ line, quantity }) {
    const cart = await getCart();
    const index = Number(line) - 1;
    const item = cart.items[index];
    const amount = Number(quantity);

    if (!item || !Number.isInteger(amount) || amount < 0) {
      return { allowed: false, message: 'Cantidad inválida.' };
    }

    // Siempre permitir disminuir a cero.
    if (amount === 0) return { allowed: true };

    const product = await getProduct(item.handle);

    if (!hasReceta(product)) {
      return { allowed: true };
    }

    const otherLines = cart.items.reduce((total, entry, i) => {
      return i !== index &&
        String(entry.product_id) === String(item.product_id)
        ? total + entry.quantity
        : total;
    }, 0);

    if (otherLines + amount > MAX_QUANTITY) {
      return {
        allowed: false,
        message: `Máximo ${MAX_QUANTITY} unidades por medicamento con receta.`
      };
    }

    return { allowed: true };
  }

  window.CetepPrescriptionLimit = Object.freeze({
    MAX_QUANTITY,
    validateAdd,
    validateChange
  });
})();
